var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seat-map-header d-none d-lg-block d-xl-block"},[(_vm.isEditing)?_c('passenger-context-display',{attrs:{"passenger":_vm.currentPassenger,"is-holding-infant":_vm.isPassengerHoldingInfant}}):_c('selection-instructions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }